import React from "react";
import { func, string } from "prop-types";

import "./custom-dropdown.m.css";

const CustomDropdown = ({ onChangeOptions, value }) => {
  let dateRange = [
    { value: "null", option: "Select a date range...", key: -1 },
    { value: "custom", option: "Custom", key: 4 },
    { value: "reset", option: "Reset date filter", key: 5 }
  ];

  return (
    <React.Fragment>
      <select value={value} styleName="dropdown" onChange={e => onChangeOptions(e)}>
        {dateRange.map(({ value, option, key }) => (
          <option key={key} value={value} label={option} />
        ))}
      </select>
    </React.Fragment>
  );
};

CustomDropdown.propTypes = {
  onChangeOptions: func,
  value: string
};

export default CustomDropdown;
